import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getListCreationError() {
      return getState().error;
    },
    isListCreationRequestFailure() {
      return getState().request.isFailure;
    },
    isListCreationRequestPending() {
      return getState().request.isPending;
    },
    isListCreationRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
